import {CustomerSubscription} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardEntryInput,
} from '@flexinet/ui-components';
import {Link} from 'react-router-dom';
import {Text} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {SubscriptionStatusBadge} from './SubscriptionStatusBadge.tsx';

export const InformationPropertyCard = ({record}: { record: CustomerSubscription }) => {

    const itemCount = Array.isArray(record.items?.items) ? record.items.items.length : 0;
    const customerLabel = record.customer?.name ?? record.customerId;

    const properties: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Subscription ID'),
            value: record.id,
            span: 12,
        }, {
            label: I18n.get('Status'),
            value: <SubscriptionStatusBadge record={record}/>,
            span: 12,
        }, {
            label: I18n.get('Customer'),
            value: (
                <Link to={`/customers/${record.customerId}`} style={{textDecoration: 'none'}}>
                    <Text c="blue">{customerLabel}</Text>
                </Link>
            ),
            span: 12,
        }, {
            label: I18n.get('Items'),
            value: String(itemCount),
            span: 12,
        }];

    const {filterAllowed} = useAllowedItems();
    const allowedProperties = filterAllowed(properties.filter(Boolean) as { rbac?: string }[]) as PlatformPropertyCardEntryInput[];

    return (<PlatformPropertyCard properties={allowedProperties}/>);
};
